export function convertToLettersOnly(input: string): string {
  // Remove any hyphens or special characters
  const cleanInput = input.replace(/[^a-zA-Z0-9]/g, "");

  let result = "";

  // For each character in the cleaned input
  for (let i = 0; i < cleanInput.length; i++) {
    const char = cleanInput[i]!;

    // If it's already a letter, keep it
    if (/[a-zA-Z]/.test(char)) {
      result += char;
    }
    // If it's a digit, convert it to a letter
    else if (/[0-9]/.test(char)) {
      // Map digits 0-9 to letters
      const charCode =
        parseInt(char) % 2 === 0
          ? 65 + parseInt(char) * 2 // Uppercase (A, C, E, G, I)
          : 97 + (parseInt(char) - 1) * 2; // Lowercase (a, c, e, g, i)

      result += String.fromCharCode(charCode);
    }
  }

  return result;
}
